import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from '../router';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authMenuItems: [],
    userInfo: {}
  },
  mutations: {
    auth_menu_items_success(state, menuItems){
        state.authMenuItems = menuItems;
        //router.push({ name: 'welcome' });
      },
      auth_menu_items_error(state){

      },
      auth_user_info(state,data){
        state.userInfo = data;
        router.push({ name: 'welcome' });
      }
  },
  actions: {
    setAuthMenuItems({commit}, url){
        return axios.get(url)
            .then(response => {
                commit('auth_menu_items_success',response.data);
            }).catch(err => {
                commit('auth_menu_items_error');
            })
    },
    setUserInfo({commit}, data){
      commit('auth_user_info',data);
    },
  },
  getters : {
    getAuthMenuItems: state => state.authMenuItems,
    getUserInfo: state => state.userInfo
  }
})